import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { toFarsiNumber } from "../../custom/helpers";
import { useGroupApi, PENDING_INVITE_KEY } from "./groupApi";
import { GroupAvatar } from "./components/ui";
import "../../styles/Fonts.css";
import "../../styles/Buttons.css";
import "../../styles/Groups.css";

// Public page (no login required to *see* the invite). The pending token is
// kept in localStorage so it survives the OTP login/signup flow and reloads.
export default function GroupInvite() {
  const { token } = useParams();
  const { call } = useGroupApi();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("token");
  const [state, setState] = useState({ status: "loading" });
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    let ignore = false;
    call(`groups/invite/${token}`, { method: "GET" })
      .then((r) => !ignore && setState({ status: "ok", data: r }))
      .catch((e) => {
        if (ignore) return;
        // dead links can't be accepted later - stop remembering them
        try { if (localStorage.getItem(PENDING_INVITE_KEY) === token) localStorage.removeItem(PENDING_INVITE_KEY); } catch (err) {}
        setState({ status: "error", code: e.code, message: e.message });
      });
    return () => { ignore = true; };
  }, [token, call]);

  const goLogin = () => {
    try { localStorage.setItem(PENDING_INVITE_KEY, token); } catch (e) {}
    navigate("/login", { state: { from: location } });
  };

  const accept = async () => {
    setJoining(true);
    try {
      const r = await call(`groups/invite/${token}/accept`, { method: "POST" });
      try { localStorage.removeItem(PENDING_INVITE_KEY); } catch (e) {}
      toast.success(r.status === "joined" ? "به گروه پیوستی 🎉" : "تو قبلا عضو این گروه بودی");
      navigate(`/groups/${r.group_id}`, { replace: true });
    } catch (e) {
      toast.error(e.message);
      setJoining(false);
    }
  };

  const decline = () => {
    try { localStorage.removeItem(PENDING_INVITE_KEY); } catch (e) {}
    navigate("/", { replace: true });
  };

  const d = state.data;
  return (
    <div className="grpPage yekan" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div className="grpPanel grpInviteCard" style={{ width: "100%", maxWidth: 440 }}>
        {state.status === "loading" && <div className="grpSkeleton" style={{ height: 200 }} />}

        {state.status === "error" && (
          <>
            <span className="grpEmptyIcon">🔗</span>
            <div className="grpEmptyTitle yekan">{state.message}</div>
            <p className="grey-2 yekan caption-1">از کسی که برات فرستاده بخواه یه لینک جدید بسازه.</p>
            <Link to="/" className="grpBtn">رفتن به خانه</Link>
          </>
        )}

        {state.status === "ok" && (
          <>
            <GroupAvatar name={d.group.name} image={d.group.image_path} size="xl" />
            <p className="grey-2 yekan caption-1" style={{ margin: 0 }}>{d.inviter_name} تو رو به این گروه دعوت کرده</p>
            <h2 className="grpTitle yekan" style={{ whiteSpace: "normal", margin: "6px 0" }}>{d.group.name}</h2>
            {d.group.description && <p className="grey-2 yekan">{d.group.description}</p>}
            <p className="grey-2 yekan caption-1">{toFarsiNumber(d.group.member_count)} عضو</p>

            {d.already_member ? (
              <>
                <div className="grpNotice grpNotice-info">تو قبلا عضو این گروه هستی</div>
                <Link to={`/groups/${d.group_id}`} className="grpBtn grpBtn-block">رفتن به گروه</Link>
              </>
            ) : isLoggedIn ? (
              <div className="grpRowWrap" style={{ justifyContent: "center", marginTop: 12 }}>
                <button type="button" className="grpBtn" disabled={joining} onClick={accept}>{joining ? "..." : "پیوستن به گروه"}</button>
                <button type="button" className="grpBtn grpBtn-ghost" onClick={decline}>الان نه</button>
              </div>
            ) : (
              <>
                <p className="grey-2 yekan caption-1" style={{ marginTop: 12 }}>برای پیوستن، وارد فودپلنر شو یا حساب بساز (فقط با شماره موبایل). دعوتت حفظ می‌شه.</p>
                <button type="button" className="grpBtn grpBtn-block" onClick={goLogin}>ورود یا ساخت حساب</button>
                <button type="button" className="grpBtn grpBtn-ghost grpBtn-block" style={{ marginTop: 8 }} onClick={decline}>الان نه</button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
